var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalerisErrorHttp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 94,
    r: 61,
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 94,
    r: 43,
    fill: "currentColor",
    fillOpacity: 0.035
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 94,
    r: 43
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 78 32 32m0-32-32 32",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 48l8 0m-4-4v8M176 133h12m-6-6v12",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 55,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 143,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 164h68",
    strokeOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalerisErrorHttp);
export default __webpack_public_path__ + "static/media/globaleris-error-http.efe97bff.svg";
export { ForwardRef as ReactComponent };